/**
 * Besucheraufkommen-Forecast-Chart (PeopleCounter).
 * Rendert pro `.pcforecast`-Element:
 *  - Tageswahl (7 Tage)
 *  - Stunden-Bars 09–20 Uhr mit Auslastungs-Farbcode (low/medium/high/closed)
 *  - Wetter-Icons via TYPO3-Proxy → OpenWeatherMap
 *
 * Daten kommen über data-pcf-* Attribute aus dem Fluid-Partial Besucheraufkommen.html.
 */
(function($) {

    var WEEKDAY_KEYS = ['so', 'mo', 'di', 'mi', 'do', 'fr', 'sa']; // moment().day() Index
    var DAY_HOURS = 12; // 9..20 inkl.
    var START_HOUR = 9;

    var BAR_CHART_LABELS = {
        de: 'Besucheraufkommen-Prognose',
        en: 'People count forecast',
        it: 'Previsione afflusso visitatori',
        nl: 'Bezoekersprognose',
        pl: 'Prognoza odwiedzin',
        cs: 'Předpověď návštěvnosti',
        hu: 'Látogatószám-előrejelzés'
    };
    var STATE_LABELS = {
        low: { de: 'niedrig', en: 'low', it: 'basso', nl: 'laag', pl: 'niski', cs: 'nízký', hu: 'alacsony' },
        medium: { de: 'mittel', en: 'medium', it: 'medio', nl: 'gemiddeld', pl: 'średni', cs: 'střední', hu: 'közepes' },
        high: { de: 'hoch', en: 'high', it: 'alto', nl: 'hoog', pl: 'wysoki', cs: 'vysoký', hu: 'magas' },
        closed: { de: 'geschlossen', en: 'closed', it: 'chiuso', nl: 'gesloten', pl: 'zamknięty', cs: 'zavřeno', hu: 'zárva' }
    };

    /**
     * App-Sprache auf eine im Projekt tatsächlich geladene moment-Locale mappen.
     * Geladen sind: en-gb, it, nl, pl, cs, hu, de-at (siehe grunt/terser.js global-Bundle).
     * Ohne dieses Mapping würde z.B. moment.locale('de') auf die globale Default-Locale
     * zurückfallen – das ist 'de-at', weil sie als letztes geladen wird.
     */
    function mapMomentLocale(lang) {
        switch ((lang || '').toLowerCase()) {
            case 'de':
                return 'de-at';
            case 'en':
                return 'en-gb';
            case 'it':
                return 'it';
            case 'nl':
                return 'nl';
            case 'pl':
                return 'pl';
            // moment kennt Tschechisch nur als 'cs'; 'cz' als Alias, falls so geliefert
            case 'cs':
            case 'cz':
                return 'cs';
            case 'hu':
                return 'hu';
            // Fallback auf Deutsch, da Projekt primär de-at-Audience
            default:
                return 'de-at';
        }
    }

    /**
     * OpenWeatherMap-Icon-Code → FontAwesome Klasse.
     */
    function owmIconToFa(icon) {
        switch (icon) {
            case '01d': return 'fa-regular fa-sun';
            case '01n': return 'fa-regular fa-moon';
            case '02d': return 'fa-regular fa-cloud-sun';
            case '02n': return 'fa-regular fa-cloud-moon';
            case '03d':
            case '03n': return 'fa-regular fa-cloud';
            case '04d':
            case '04n': return 'fa-regular fa-clouds';
            case '09d':
            case '09n': return 'fa-regular fa-cloud-showers-heavy';
            case '10d': return 'fa-regular fa-cloud-sun-rain';
            case '10n': return 'fa-regular fa-cloud-moon-rain';
            case '11d':
            case '11n': return 'fa-regular fa-bolt';
            case '13d':
            case '13n': return 'fa-regular fa-snowflake';
            case '50d':
            case '50n': return 'fa-regular fa-smog';
            default: return '';
        }
    }

    /**
     * Textalternativen der Wetter-Icons aus dem data-Attribut lesen.
     * Format: "01d:Sonnig;01n:Klare Nacht;..." (OpenWeatherMap-Iconcode:Text).
     */
    function parseWeatherLabels(raw) {
        var map = {};
        String(raw || '').split(';').forEach(function(pair) {
            var idx = pair.indexOf(':');
            if (idx < 1) { return; }
            var key = pair.slice(0, idx).trim();
            var label = pair.slice(idx + 1).trim();
            if (key && label) { map[key] = label; }
        });
        return map;
    }

    function PeopleCountForecast($el) {
        this.$el = $el;
        this.data = $el.data();
        this.lang = mapMomentLocale(this.data.pcfLang);

        this.start = moment(this.data.pcfStart);
        this.values = String(this.data.pcfValues || '').split(',').map(function(v) {
            if (v === '' || v === undefined) { return null; }
            var n = parseInt(v, 10);
            return isNaN(n) ? null : n;
        });
        this.thHigh = parseInt(this.data.pcfThHigh, 10) || 99999;
        this.thMedium = parseInt(this.data.pcfThMedium, 10) || 99999;

        this.closedByWeekday = {
            mo: this.data.pcfClosedMo === 1 || this.data.pcfClosedMo === '1',
            di: this.data.pcfClosedDi === 1 || this.data.pcfClosedDi === '1',
            mi: this.data.pcfClosedMi === 1 || this.data.pcfClosedMi === '1',
            do: this.data.pcfClosedDo === 1 || this.data.pcfClosedDo === '1',
            fr: this.data.pcfClosedFr === 1 || this.data.pcfClosedFr === '1',
            sa: this.data.pcfClosedSa === 1 || this.data.pcfClosedSa === '1',
            so: this.data.pcfClosedSo === 1 || this.data.pcfClosedSo === '1'
        };

        this.weatherLabels = parseWeatherLabels(this.data.pcfWeatherLabels);
        this.weatherPrefix = String(this.data.pcfWeatherPrefix || '').trim();

        // Wird gesetzt, wenn ein Tagwechsel den Re-Render ausgelöst hat – dann muss
        // der Fokus zurück auf den gewählten Tag (WCAG 2.4.3 Focus Order).
        this.focusSelectedDay = false;

        this.allBars = this.buildAllBars();
        this.availableDays = this.buildAvailableDays();
        this.selectedDay = this.pickInitialDay();
        this.weather = null;
    }

    PeopleCountForecast.prototype.buildAllBars = function() {
        var self = this;
        return this.values.map(function(value, i) {
            var t = self.start.clone().add(i, 'hours');
            var state;
            if (value === null) {
                state = 'low';
            } else if (value >= self.thHigh) {
                state = 'high';
            } else if (value >= self.thMedium) {
                state = 'medium';
            } else {
                state = 'low';
            }
            if (self.isClosedAt(t)) { state = 'closed'; }
            return { value: value, state: state, timestamp: t };
        });
    };

    PeopleCountForecast.prototype.isClosedAt = function(m) {
        var key = WEEKDAY_KEYS[m.day()];
        return !!this.closedByWeekday[key];
    };

    PeopleCountForecast.prototype.buildAvailableDays = function() {
        var days = [];
        if (this.allBars.length === 0) { return days; }
        var today = moment().startOf('day');
        var d = today.isAfter(this.start) ? today : this.start.clone().startOf('day');
        var endDay = this.allBars[this.allBars.length - 1].timestamp.clone().startOf('day');
        for (var i = 0; i < 7; i++) {
            if (d.isAfter(endDay)) { break; }
            days.push({
                iso: d.toISOString(),
                date: d.clone(),
                label: d.locale(this.lang).format('dd'),
                enabled: !this.isClosedAt(d)
            });
            d.add(1, 'day');
        }
        return days;
    };

    PeopleCountForecast.prototype.pickInitialDay = function() {
        return this.availableDays.length > 0 ? this.availableDays[0].iso : null;
    };

    PeopleCountForecast.prototype.upperBound = function() {
        var max = 0;
        this.allBars.forEach(function(b) {
            if (b.value !== null && b.value > max) { max = b.value; }
        });
        return max || 1;
    };

    PeopleCountForecast.prototype.visibleStart = function() {
        var dayMoment = this.selectedDay ? moment(this.selectedDay) : this.start.clone();
        return dayMoment.clone().hour(START_HOUR).minute(0).second(0).millisecond(0);
    };

    PeopleCountForecast.prototype.visibleBars = function() {
        var vs = this.visibleStart();
        var startIdx = -1;
        for (var i = 0; i < this.allBars.length; i++) {
            if (this.allBars[i].timestamp.isSame(vs)) { startIdx = i; break; }
        }
        if (startIdx === -1) {
            // Fallback: erste Bar dieses Tages
            for (var j = 0; j < this.allBars.length; j++) {
                if (this.allBars[j].timestamp.isSame(vs, 'day')) { startIdx = j; break; }
            }
        }
        if (startIdx === -1) { return []; }
        return this.allBars.slice(startIdx, startIdx + DAY_HOURS);
    };

    /**
     * Textalternative fuer das Wetter-Icon zu einem Zeitpunkt.
     * Quelle: data-pcf-weather-labels / data-pcf-weather-prefix.
     */
    PeopleCountForecast.prototype.weatherTextAt = function(m) {
        var fc = this.getWeatherAt(m);
        if (!fc || !fc.icon) { return ''; }
        var label = this.weatherLabels[fc.icon];
        if (!label) { return ''; }
        return (this.weatherPrefix ? this.weatherPrefix + ': ' : '') + label;
    };

    PeopleCountForecast.prototype.render = function() {
        var self = this;
        var upper = this.upperBound();
        var bars = this.visibleBars();
        var rawLang = (this.data.pcfLang || 'de').toLowerCase();
        var closedLabel = STATE_LABELS.closed[rawLang] || STATE_LABELS.closed['de'];
        var dayLabelText = this.visibleStart().locale(this.lang).format('dddd, D. MMMM YYYY');

        var $wrap = $('<div class="pcforecast-inner"></div>');

        // Tag-Tabs: echte Buttons statt <a href="#"> – die Tage navigieren nicht,
        // sie schalten den Chart um.
        var $daylist = $('<div class="daylist" role="list"></div>');
        var $selectedDayBtn = null;
        this.availableDays.forEach(function(day) {
            var isSelected = day.iso === self.selectedDay;
            var $dayDiv = $('<div role="listitem"></div>')
                .toggleClass('selected', isSelected);

            // aria-label ueberschreibt den sichtbaren Kurztext ("Mo") mit dem vollen Datum;
            // bei geschlossenen Tagen kommt der Grund mit rein, weil ein zusaetzlicher
            // sr-only-Text neben aria-label nicht vorgelesen wuerde.
            var ariaLabel = day.date.locale(self.lang).format('dddd, D. MMMM YYYY');
            if (!day.enabled) { ariaLabel += ' (' + closedLabel + ')'; }

            var $btn = $('<button type="button"></button>')
                .text(day.label)
                .attr('aria-label', ariaLabel)
                .toggleClass('disabled', !day.enabled)
                .on('click', function() {
                    // aria-disabled statt disabled: Der Tag bleibt fokussierbar und
                    // auffindbar, der Klick wird hier abgefangen.
                    if (!day.enabled) { return; }
                    self.selectedDay = day.iso;
                    self.focusSelectedDay = true;
                    self.render();
                });
            if (!day.enabled) {
                $btn.attr('aria-disabled', 'true');
            }
            if (isSelected) {
                $btn.attr('aria-current', 'date');
                $selectedDayBtn = $btn;
            }
            $dayDiv.append($btn);
            $daylist.append($dayDiv);
        });
        $wrap.append($daylist);

        // Day-Label vor dem Chart: das Datum muss gelesen werden, bevor die Werte kommen.
        $wrap.append($('<div class="daylabel"></div>').text(dayLabelText));

        // Y-Achse
        var $yAxis = $('<div class="y-axis" aria-hidden="true"></div>');
        [100, 75, 50, 25, 0].forEach(function(pct) {
            $('<span></span>').text(pct + '%').css('bottom', pct + '%').appendTo($yAxis);
        });

        // Chart-Body mit Gridlines + Bars
        var $chartBody = $('<div class="chart-body"></div>');
        [0, 25, 50, 75, 100].forEach(function(pct) {
            $('<div class="gridline"></div>').css('bottom', pct + '%').appendTo($chartBody);
        });

        // Liste statt role="img": bei role="img" wuerden alle Kindknoten – und damit
        // saemtliche sr-only-Texte der Bars – aus dem Accessibility-Tree fallen.
        var barsLabel = BAR_CHART_LABELS[rawLang] || BAR_CHART_LABELS['de'];
        var $bars = $('<div class="bars" role="list"></div>')
            .attr('aria-label', barsLabel + ' – ' + dayLabelText);
        bars.forEach(function(bar) {
            var $bar = $('<div class="bar" role="listitem"></div>');
            var heightPct = bar.state === 'closed' ? 6 : Math.max(2, Math.round((bar.value || 0) / upper * 100));
            $('<div class="bar-fill"></div>')
                .addClass('state-' + bar.state)
                .css('height', heightPct + '%')
                .appendTo($bar);
            var stateLabel = (STATE_LABELS[bar.state] && STATE_LABELS[bar.state][rawLang]) || STATE_LABELS[bar.state]['de'];
            var srText = bar.timestamp.format('HH:00') + ' – ' + stateLabel + ' (' + heightPct + '%)';
            // Wetter gehoert zur selben Stunde – zusammen in einem Listeneintrag statt
            // als zweite, separat vorgelesene Zeitreihe.
            var weatherText = self.weatherTextAt(bar.timestamp);
            if (weatherText) { srText += ', ' + weatherText; }
            $('<span class="sr-only"></span>').text(srText).appendTo($bar);
            $bars.append($bar);
        });

        $chartBody.append($bars);
        $wrap.append($('<div class="pcforecast-chart"></div>').append($yAxis).append($chartBody));

        // Wetter-Icons: rein visuelle Wiederholung der Bar-Texte -> aus dem A11y-Tree.
        var $weather = $('<div class="weather" aria-hidden="true"></div>');
        bars.forEach(function(bar) {
            var $w = $('<div></div>');
            var fc = self.getWeatherAt(bar.timestamp);
            if (fc && fc.icon) {
                $('<span></span>').attr('class', owmIconToFa(fc.icon)).appendTo($w);
            }
            $weather.append($w);
        });
        $wrap.append($weather);

        // Stunden-Labels (09:00 / 12:00 / ...) – HH:mm ist sprachneutral und schon
        // als Uhrzeit erkennbar, braucht also keine uebersetzte Einheit.
        // Doppeln die Bar-Texte, daher aria-hidden.
        var $labels = $('<div class="labels" aria-hidden="true"></div>');
        if (bars.length > 0) {
            for (var h = 0; h <= bars.length; h += 3) {
                var t = bars[0].timestamp.clone().add(h, 'hours');
                $labels.append($('<div></div>').text(t.format('HH:mm')));
            }
        }
        $wrap.append($labels);

        this.$content.empty().append($wrap);

        // Nach einem Tagwechsel Fokus zurueckgeben und den neuen Tag ansagen.
        if (this.focusSelectedDay) {
            this.focusSelectedDay = false;
            if ($selectedDayBtn) { $selectedDayBtn.trigger('focus'); }
            this.$status.text(dayLabelText);
        }
    };

    PeopleCountForecast.prototype.getWeatherAt = function(m) {
        if (!this.weather || !this.weather.list) { return null; }
        var ts = m.unix();
        // OWM Forecast hat 3h-Intervalle → fuzzy match ±1h
        return this.weather.list.find(function(w) {
            return Math.abs(w.dt - ts) <= 3600;
        }) || null;
    };

    PeopleCountForecast.prototype.loadWeather = function() {
        var self = this;
        var lat = parseFloat(this.data.pcfLat);
        var lon = parseFloat(this.data.pcfLon);
        if (!lat || !lon) { return; }

        var sysLanguageUid = $('.ttgDataWrapperOnlyNeededForJS').data('actlanguagesysuid') || 0;
        var rootPageId = (typeof rootPage !== 'undefined') ? rootPage : $('body').data('rootpage');

        $.ajax({
            method: 'GET',
            url: '/index.php?id=' + rootPageId + '&type=1955&L=' + sysLanguageUid,
            data: { lat: lat, lon: lon },
            dataType: 'json'
        }).done(function(response) {
            self.weather = response;
            self.render();
        }).fail(function() {
            // Wetter-Sektion bleibt leer – Chart funktioniert auch ohne
        });
    };

    PeopleCountForecast.prototype.init = function() {
        if (this.allBars.length === 0 || this.availableDays.length === 0) {
            this.$el.closest('#ttgAccordionBesucheraufkommen').remove();
            return;
        }
        this.$el.removeAttr('aria-busy');
        // Der Status-Container liegt ausserhalb von $content und ueberlebt jeden
        // Re-Render – nur so sagt die Live-Region den Tagwechsel zuverlaessig an.
        this.$content = $('<div class="pcforecast-content"></div>');
        this.$status = $('<div class="sr-only" role="status" aria-live="polite"></div>');
        this.$el.empty().append(this.$content).append(this.$status);
        this.render();
        this.loadWeather();
    };

    // Initialisiert alle noch nicht verarbeiteten .pcforecast-Elemente.
    // Global exponiert, damit auch AJAX-nachgeladene Inhalte (Berichtsdaten-Reload) den Chart aufbauen.
    function initPeopleCountForecast() {
        $('.pcforecast').each(function() {
            var $el = $(this);
            if ($el.data('pcfInit')) { return; } // Doppel-Init nach AJAX vermeiden
            $el.data('pcfInit', true);
            try {
                new PeopleCountForecast($el).init();
            } catch (e) {
                $el.closest('#ttgAccordionBesucheraufkommen').remove();
                if (window.console && console.warn) { console.warn('PeopleCountForecast init failed:', e); }
            }
        });
    }
    window.ttgInitPeopleCountForecast = initPeopleCountForecast;

    $(document).ready(initPeopleCountForecast);

})(jQuery);
